import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

const { getShippingFlowAPI } = useAxiosAPI();

const modalStore = useModalStore();
const { closeModal } = modalStore;

function useShippingProgress(props) {
  const data = ref([]);
  const dataIsLoad = ref(false);
  const dataEn = ref({
    處理中: 'Processing',
    準備中: 'Packing',
    已出貨: 'Shipped',
    已到貨: 'Delivered',
    貨到門市: 'Delivered',
    配送異常: 'Exception',
    退貨至倉庫: 'Return to warehouse',
    退貨申請: 'Applying',
    物流處理中: 'Processing',
    檢查退貨商品中: 'Checking',
    退貨審核完成: 'Review Process',
    退貨處理完成: 'Return Confirmed',
    退貨取消: '',
    退款完成: 'Refund Confirmed',
    貨故: '',
  });
  const link = ref(null);
  const shippingNumber = ref(null);

  function fetchAPI() {
    getShippingFlowAPI({
      params: {
        TransactionID: props.transactionId,
        WmsTransactionID: props.wmstransactionId,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          data.value = res.data.Response;
          dataIsLoad.value = true;

          if (res.data.Response.StatusUrl && res.data.Response.ShippingNumber) {
            link.value = res.data.Response.StatusUrl;
            shippingNumber.value = res.data.Response.ShippingNumber;
          }
        } else {
          closeModal();
        }
      })
      .catch((error) => {
        console.log(error);
        closeModal();
      });
  }

  return {
    data,
    dataIsLoad,
    dataEn,
    link,
    shippingNumber,
    fetchAPI,
  };
}

export default useShippingProgress;
